<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="`${this.$store.state.isRTL ? '' : ' me-sm-6'} ${this.$store.state.isNavFixed ? 'text-dark' : 'text-white' }`"
    >
      <li class="text-sm breadcrumb-item">
        <router-link :class="this.$store.state.isNavFixed ? 'text-dark' : 'text-white'"  :to="'/dashboard'">
          Inicio
        </router-link>
      </li>
      <li class="text-sm breadcrumb-item" v-for="(crumb, index) in breadcrumb" :key="index">
        <router-link class="text-white text-sm breadcrumb-item" v-if="index < breadcrumb.length - 1" :to="crumb.path">
          {{ crumb.text }}
        </router-link>
        <span v-else>{{ crumb.text }}</span>
      </li>

    </ol>
   
  </nav>
</template>

<script>

import { useRoute, useRouter } from 'vue-router';

import { defineComponent } from 'vue';

export default defineComponent({
  name: "breadcrumbs",
  props: {
    currentPage: {
      required: true
    },
    textWhite: {
      type: String
    }
  },
  data() {
    return {
      route : useRoute()
    }
  },
  computed: {
    breadcrumb() {

      let p = []
      
      this.$route.matched.map(route => {
        let path = route.path;

        if(route.meta.breadcrumb)p.push(...route.meta.breadcrumb);
        
        Object.keys(this.$route.params).forEach(param => {
          path = path.replace(`:${param}`, this.$route.params[param]);
        });

        if(this.$route.params.id){

          p.push({
            text: route.name , // Nome da rota ou o id
            path
          });

        }

        p.push({
          text: this.$route.params.id || route.name , // Nome da rota ou o id
          path
        });

      });

      return p;
    }
  }
});
</script>
